import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams';
import { omaElisaForCompaniesMsg, ordersMsg, t } from '../../../../../common/i18n/index.js';
import { CustomerOrderDetails } from '../../../../../components/CustomerOrderDetails/CustomerOrderDetails.js';
import { getCustomerOrderId, isCustomerOrder } from '../../../../../components/CustomerOrderList/customerOrderUtils';
import type { CustomerOrderLoaderData } from '../../../../../common/loaders.js';

export const CustomerOrderPath = () => {
  const {
    customerOrder,
    additionalInfo,
    companyInfo,
    contacts,
    billingAccounts,
    changeRequestDetails,
    customerOrderDescription,
  } = useLoaderData() as CustomerOrderLoaderData;
  const { mdmId } = useSearchParams<{ mdmId: string }>();
  const isCo = isCustomerOrder(customerOrder);

  return (
    <CustomerOrderDetails
      pathTemplate={paths.CUSTOMER_ORDER_PRODUCT}
      contacts={contacts?.searchResults}
      customerOrder={isCo ? customerOrder : undefined}
      changeRequestDetails={!isCo ? changeRequestDetails : undefined}
      deviceSubscriptions={additionalInfo?.ordererSubscriptions}
      breadCrumbPaths={[
        { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
        { name: t.I9C0(ordersMsg), path: paths.CUSTOMER_ORDERS },
        { name: getCustomerOrderId(customerOrder, changeRequestDetails) },
      ]}
      customerType={companyInfo?.customerType}
      billingAccounts={billingAccounts?.searchResults}
      mdmId={mdmId!}
      customerOrderDescription={customerOrderDescription}
    />
  );
};
